import { c as _c } from "react/compiler-runtime";
import { FilterDateRange } from '@onefootprint/ui';
import { useRouter } from 'next/router';
import { parseAsArrayOf, parseAsString, useQueryStates } from 'nuqs';
import getDateRange from '@/utils/get-date-range';
export type SecurityLogsQuery = {
  dateRange: FilterDateRange;
  search: string;
  names: string[];
};
const defaultQueryParams: SecurityLogsQuery = {
  dateRange: FilterDateRange.AllTime,
  search: '',
  names: []
};
const useSecurityLogsQueryParams = () => {
  const $ = _c(23);
  const router = useRouter();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      date_range: parseAsString.withDefault(defaultQueryParams.dateRange),
      search: parseAsString.withDefault(defaultQueryParams.search),
      names: parseAsArrayOf(parseAsString).withDefault(defaultQueryParams.names)
    };
    t1 = {
      history: "push",
      clearOnDefault: true
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const [queryParams, setQueryParams] = useQueryStates(t0, t1);
  let filtersCount;
  let hasFilters;
  let t2;
  let t3;
  let t4;
  let t5;
  let values;
  if ($[2] !== queryParams.date_range || $[3] !== queryParams.names || $[4] !== queryParams.search || $[5] !== router.isReady || $[6] !== router.query || $[7] !== setQueryParams) {
    const push = newQuery => {
      const updated = {
        ...values,
        ...newQuery
      };
      setQueryParams({
        date_range: updated.dateRange ?? defaultQueryParams.dateRange,
        search: updated.search ?? defaultQueryParams.search,
        names: updated.names ?? defaultQueryParams.names
      });
    };
    values = {
      dateRange: queryParams.date_range as FilterDateRange,
      search: queryParams.search,
      names: queryParams.names
    };
    hasFilters = values.names.length > 0 || values.dateRange !== FilterDateRange.AllTime;
    filtersCount = values.names.length + (values.dateRange !== FilterDateRange.AllTime ? 1 : 0);
    const getRequestParams = () => {
      const {
        from,
        to
      } = getDateRange([values.dateRange]);
      const params = {};
      if (from) {
        params.timestamp_gte = from;
      }
      if (to) {
        params.timestamp_lte = to;
      }
      if (values.search && values.search.trim().length > 0) {
        params.search = values.search;
      }
      if (values.names.length) {
        params.names = router.query.names as string;
      }
      return params;
    };
    t2 = router.isReady;
    t3 = () => push({
      dateRange: defaultQueryParams.dateRange,
      names: defaultQueryParams.names
    });
    t4 = push;
    t5 = getRequestParams();
    $[2] = queryParams.date_range;
    $[3] = queryParams.names;
    $[4] = queryParams.search;
    $[5] = router.isReady;
    $[6] = router.query;
    $[7] = setQueryParams;
    $[8] = filtersCount;
    $[9] = hasFilters;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = values;
  } else {
    filtersCount = $[8];
    hasFilters = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    values = $[14];
  }
  let t6;
  if ($[15] !== filtersCount || $[16] !== hasFilters || $[17] !== t2 || $[18] !== t3 || $[19] !== t4 || $[20] !== t5 || $[21] !== values) {
    t6 = {
      isReady: t2,
      clearFilters: t3,
      push: t4,
      requestParams: t5,
      values,
      hasFilters,
      filtersCount
    };
    $[15] = filtersCount;
    $[16] = hasFilters;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = values;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
};
export default useSecurityLogsQueryParams;